export function objectToLookup(obj: any): Array<{
  code: string
  name: string
}> {
  if (typeof obj !== 'object' || Array.isArray(obj)) return []
  return Object.entries(obj).map(([key, value]) => {
    return { code: key, name: value as string }
  })
}

export function emptyStrToUndefined(
  str: string | null | undefined
): string | undefined {
  if (str == null || str === '') return undefined
  return str
}

export function stringToNumber(str: string | null | undefined): number | undefined {
  if (str == null) return undefined
  const _number = Number(str)
  if (isNaN(_number)) return undefined
  return _number
}

export type PriceType = {
  price: number | null | undefined
  currency: string | null | undefined
}
export const priceFormat = ({ price, currency }: PriceType): string => {
  if (price == null) return ''
  const _priceFormat =
    price
      ?.toFixed(2)
      .replace(/\.0+$/, '')
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +
    ' ' +
    (currency ?? '')
  return _priceFormat
}

export const amountReplace = (amount: string) => {
  return amount.replace(',', '.').replace('..', '.')
}
